import { Link, useSearchParams } from "react-router-dom";
import { Clock, CheckCircle2 } from "lucide-react";
import { LOGOS } from "../../lib/ablemp-data";
import { useAuth } from "../AuthContext";

export default function AguardandoAprovacao() {
  const { user, logout } = useAuth();
  const [params] = useSearchParams();
  const submitted = params.get("submitted") === "1";

  return (
    <div className="min-h-screen bg-[#0A0F14] text-white flex items-center justify-center p-6">
      <div className="max-w-xl text-center">
        <Link to="/" className="inline-block mb-8">
          <img src={LOGOS.white} alt="ABLEMP" className="h-14 w-auto mx-auto" />
        </Link>
        <div className="h-16 w-16 mx-auto rounded-full border border-[#FEDF00]/40 grid place-items-center text-[#FEDF00]">
          {submitted ? (
            <CheckCircle2 size={28} strokeWidth={1.6} />
          ) : (
            <Clock size={28} strokeWidth={1.4} />
          )}
        </div>
        <div className="mt-6 text-[11px] uppercase tracking-[0.3em] text-[#FEDF00]">
          {submitted
            ? "Solicitação enviada"
            : "Aguardando aprovação"}
        </div>
        <h1 className="mt-4 font-serif-display text-3xl md:text-4xl leading-tight">
          {submitted ? (
            <>
              Recebemos sua solicitação. Em breve nossa{" "}
              <span className="italic font-light text-[#FEDF00]">
                administração
              </span>{" "}
              entrará em contato.
            </>
          ) : (
            <>
              Seu cadastro está em análise pelo{" "}
              <span className="italic font-light text-[#FEDF00]">administrador</span>.
            </>
          )}
        </h1>
        <p className="mt-4 text-white/65 leading-relaxed">
          {submitted
            ? "Seus dados e documentos foram enviados para avaliação. Você receberá uma confirmação por e-mail assim que a administração aprovar sua associação."
            : "Em breve você receberá a confirmação. Assim que sua conta for aprovada, basta entrar novamente para acessar o portal."}
          {user?.email && (
            <>
              <br />
              <span className="text-white/45 text-sm">
                Conta vinculada: <strong>{user.email}</strong>
              </span>
            </>
          )}
        </p>
        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/"
            className="px-6 py-3 text-[12px] uppercase tracking-[0.22em] font-semibold border border-white/30 hover:border-[#FEDF00] hover:text-[#FEDF00] transition-colors"
          >
            Voltar ao site
          </Link>
          {user && (
            <button
              data-testid="logout-pending"
              onClick={logout}
              className="px-6 py-3 text-[12px] uppercase tracking-[0.22em] font-semibold bg-[#FEDF00] text-[#0A0F14] hover:bg-white transition-colors"
            >
              Sair
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
